import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import noConnectionIcon from 'src/assets/icons/noConnection.svg';

import SmallModalTemplate from 'src/components/SmallModalTemplate';

import { I18NextNS } from 'src/models/Language.model';

import ReconnectionFailedCard from './ReconnectionFailedCard';

type ConnectionIssueModalProps = {
  show: boolean;
  shouldShowCard: boolean;
  isCheckingConnection: boolean;
  handleCheckConnection: () => void;
  secondaryButton?: React.ReactNode;
};

export default function ConnectionIssueModal({
  show,
  shouldShowCard,
  isCheckingConnection,
  handleCheckConnection,
  secondaryButton,
}: ConnectionIssueModalProps) {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'connectionIssue.connectionIssueModal',
  });

  return (
    <SmallModalTemplate
      show={show}
      icon={<img src={noConnectionIcon} alt={t('noConnectionImgAlt')} />}
      iconWrapperClassName="bg-danger-100"
      title={t('title')}
      description={t('description')}
      backdropClassName="connection-issue-backdrop"
      style={{ zIndex: 2000 }}
      animation={false}
      card={shouldShowCard ? <ReconnectionFailedCard /> : undefined}
      leftButton={secondaryButton}
      rightButton={
        isCheckingConnection ? (
          <Button variant="primary" className="button-slim" disabled>
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                className="me-2"
              />
              {t('retryingConnection')}
            </>
          </Button>
        ) : (
          <Button
            variant="primary"
            className="button-slim"
            onClick={handleCheckConnection}
          >
            {t('retryConnection')}
          </Button>
        )
      }
    />
  );
}
